import { api } from './api';

export const fetchTodosClientes    = (params) => api.get('/web/todosclientes/', { params });
export const fetchClienteInfo      = (params) => api.get('/web/clieantefind/', { params });
export const fetchClienteByContador = (params) => api.get('/web/searchclient-web/', { params });
export const searchContador        = (params) => api.get('/web/contador/', { params });
export const fetchListaContadores  = (params) => api.get('/web/listacontadores/', { params });
export const fetchContadoresDisp   = (params) => api.get('/web/TodosCDisponiveis/', { params });
export const fetchReclamacoes      = (params) => api.get('/web/ClienteReclamacoes', { params });
export const fetchTokensCliente    = (params) => api.get('/web/TokensRecarga', { params });
export const fetchMediaCliente     = (params) => api.get('/web/MediaCompraRecarga', { params });
export const adicionarDivida       = (data)   => api.post('/web/AdicionarDivida/', data);
export const fetchDividasCliente   = (data)   => api.post('/web/clieantedividas/', data);
export const pagarDivida           = (data)   => api.post('/web/pagardivida/', data);
export const enviarMensagem        = (data)   => api.post('/web/EnviarMensagem/', data);
export const registarCliente       = (data)   => api.post('/web/registarcliente/', data);
export const fetchClienteBairros   = ()       => api.get('/web/clientes/bairros/');
export const updateCliente         = (data)   => api.post('/web/updatecliente/', data);
export const adicionarMeter        = (data)   => api.post('/web/AdicionarMeter/', data);
export const actualizarContadores  = (data)   => api.post('/web/ActualizeContadores/', data);
export const deleteUser            = (data)   => api.post('/web/DeleteUser', data);
export const importClientesExcel   = (formData) => api.post('/web/exportclient/', formData);
export const exportCliente         = (params) => api.get('/web/exports/clientes/', { params });
export const refundCliente         = (data)   => api.post('/web/RefundCliente/', data);

export const resetPassword = (data) => api.post('/api/password_reset/', data);

export const confirmResetPassword = (data) => api.post('/api/password_reset/confirm/', data);
